import { BASE_URL } from './config';

///cheking if token is expired or not uding jwt

function isTokenExpired(token) {
  if (!token) return true;
  try {
    const [, payloadBase64] = token.split('.');
    const payload = JSON.parse(atob(payloadBase64));
    const exp = payload.exp;
    if (!exp) return true;
    const now = Math.floor(Date.now() / 1000);
    return now >= exp;
  } catch {
    return true;
  }
}


async function getNewAccessToken() {
  try {
    const res = await fetch(`${BASE_URL}/token/generate-access-token`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    if (!res.ok) {
      let errorText = '';
      try {
        errorText = JSON.stringify(await res.json());
      } catch {
        errorText = await res.text();
      }
      throw new Error(`Token refresh failed (${res.status}): ${errorText}`);
    }


    const data = await res.json();
    if (!data.token) throw new Error('No token returned in response');

    localStorage.setItem('token', data.token);
    return data.token;
  } catch (err) {
    console.error('Error in getNewAccessToken:', err);
    throw err;
  }
}

export async function authFetch(url, options = {}) {
  let token = localStorage.getItem('token');

  if (!token || isTokenExpired(token)) {
    try {
      token = await getNewAccessToken();
      console.log('Token refreshed:', token);
    } catch (err) {
      console.error('Failed to get new access token:', err);
      throw err;
    }
  } else {
    console.log('Using existing valid token');
  }

  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const isFormData = options.body instanceof FormData;
  if (!isFormData) {
    headers['Content-Type'] = 'application/json';
  } else {
    headers['Accept'] = 'application/json';
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  return response;
}
